import pluralize from 'pluralize';

class Promocode {
  previewCode = null;

  type = null;

  code = null;

  constructor(code = null, type = null, durationLength = null, durationUnit = null, discountType = null, discountValue = null, targetType = null) {
    this.type = type;
    this.code = code;
    this.duration_length = durationLength;
    this.duration_unit = durationUnit;
    this.discount_type = discountType;
    this.discount_value = discountValue;
    this.target_type = targetType;
  }

  static fromJson(promocode) {
    return new Promocode(
      promocode.code,
      promocode.type,
      promocode.duration_length,
      promocode.duration_unit,
      promocode.discount_type,
      promocode.discount_value,
      promocode.target_type,
    );
  }

  get component() {
    if (this.type && this.type === 'free_trial') {
      return 'free-trial';
    }
    return 'coupon';
  }

  get displayComponent() {
    return this.isRunning;
  }

  get isRunning() {
    return this.code !== null;
  }

  get prettyDescription() {
    if (this.code === null) {
      return '';
    }

    let text = `<span>${this.code}`;
    if (this.type === 'free_trial') {
      text += ' free trial';
    } else if (this.type === 'coupon') {
      text += ` discount ${this.discount_type === 'percent_off' ? `${this.discount_value}%` : `${this.selectedCurrency ? this.selectedCurrency.symbol : '£'}${this.discount_value}`} off`;
    }
    text += '</span>';
    if (this.target_type === 'purchase') {
      text += ' a book purchase';
    } else if (this.target_type === 'subscription') {
      if (this.duration_length > 0) {
        text += ` for ${pluralize(this.duration_unit, this.duration_length, true)}`;
      }
    }

    return text;
  }

  get longerPrettyDescription() {
    if (this.type === 'free_trial') {
      return `Your first ${pluralize(this.duration_unit, this.duration_length, true)} on this subscription are free.`;
    }
    if (this.type === 'coupon') {
      return `Your first ${pluralize(this.duration_unit, this.duration_length, true)} on this subscription will be discounted.`;
    }

    return null;
  }
}

export default Promocode;
